<template>
  <section>
    <LoadingSpinner v-if="loading" />

    <!-- Table (list orders) + -->
    <div class="row flex-grow-1 overflow-auto my-4 px-2">

      <!-- select para ORDENAR a nivel de frontend -->
      <div class="col-12" v-if="!loading">
        <div class="row">
          <div class="col-12">
            
            <!-- Muestro total de resultados de la consulta -->
            <span class="ml-1 mr-4 font-weight-bold">Result:
              <span v-if="orders.length > 0">{{ orders.length - 1}}</span>
              <span v-else>0</span>
            </span>

            <span class="ml-2">{{ $t("lang.label.orderby") }}:</span>
          <!-- </div>
          <div class="col-3"> -->
          <span class="mx-2">
            <select v-model="orderBy" @change="updateOrder" class="form-control">
            <option value="created">{{ this.$t("lang.column.creation") }}</option>
            <option value="client_name">Client</option>
            <option value="target_name">Target name</option>
            <option value="launch_date_campaign">{{ this.$t("lang.column.launch_date")}}</option>
            <option value="prospecting_days">{{ this.$t("lang.column.prospecting_days") }}</option>
            <option value="total_newprospects">{{ this.$t("lang.label.newleads") }}</option>
            <option value="total_email_sent">Total sent</option>
            <option value="conversion_rate">Meetings / unique prospects (month)</option>
            <option value="simple_meeting_rate">Meetings/Email sent (month)</option>
            <option value="meeting_rate">Meetings / unique prospects (global)</option>
            <option value="total_event">Total Event</option>
            <option value="revenue">Revenue</option>            
          </select>
          </span>
          <!-- </div>
          <div class="col-2"> -->
          <span class="mx-2">
          <select v-model="orderDirection" @change="updateOrder" class="form-control">
            <option value="asc">Asc</option>
            <option value="desc">Desc</option>
          </select>
          </span>
          </div>
        </div>        
      </div>      

   

      <!-- Tabla de datos -->
      <div class="col=12 w-100 my-2" style="height: 45vh; overflow-x: hidden;">
        <div class="mx-0 px-0 table-responsive">
          <Table
            v-if="!loading && !showEmptyImage"
            class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="orders"
            :checkbox="false"
            :notselect="true"
            :model="model"
            :fieldsLoading="fieldsLoading"
            :key="captainkey"
            @editOrder="editOrder"
            @openTarget="openTarget"
            @openClient="openClient">
          </Table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { targetsService, usersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  name: 'OrderPerformanceToSaleDashboard',
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
    ordersPreparingAndNotVerified() {
      return this.ordersStatus.filter(
        (el) => el.target_status_id === "1" && el.target_validation === "0"
      );
    },
    ordersPreparingAndVerified() {
      return this.ordersStatus.filter(
        (el) =>
          el.target_status_id === "1" &&
          el.target_validation === "1" &&
          parseInt(el.prospectors_active) > 3
      );
    },
  },

  data() {
    return {
      orderDirection: 'desc',
      orderBy: 'simple_meeting_rate', 
      filters: [],
      fullview: false,
      filterkey: 2233,
      ordersStatus: [],
      fieldsLoading: true,
      sort: "",
      dir: "",
      keyFilter: 1,
      searchFilter: {},
      oldQuery: "  ",
      orderStatus: 10,
      loading: true,
      typelist: 10,
      typelistPreparing: 10,
      filterColumn: [],
      orders: [],
      showEmptyImage: false,

      captainkey: 112000,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "created",
          },
        ],
        [
          {
            value: "id",
          },
        ],
        [
          {
            value: "tasks",
          },
        ],
        [
          {
            value: "closetask",
          },
        ],
        [
          {
            value_label: "target_name",
            value_emit: "id",
            class: "text-primary",
            textShort: 40,
            type: "emit",
            emit: "openTarget",
            badges: [
              {
                badge_if: "stats",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.label.nonverified"),
                badge_tooltip: this.$t("lang.label.refused_tooltip"),
              },
              {
                badge_if: "stats",
                badge_value: "1",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.label.verified"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "stats",
                badge_value: "0",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.label.unverified"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
             badges: [
              {
                badge_if: "client_status_id",
                badge_value: "2",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.onBoarding.onboarding"),
                badge_tooltip: this.$t("lang.label.refused_tooltip"),
              },

              {
                badge_if: "client_status_id",
                badge_value: "9",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.label.validating"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "3",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.label.active"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "5",
                badge_class: "badge badge-info text-white",
                badge_label: this.$t("lang.appointments.standby"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "8",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.label.pendingdeleted"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "7",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.payment.Recovery"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "6",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.label.deleted"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value: "duplicate_reason",
          },
        ],
        [
          {
            value_emit: "id",
            value: "target_status_id",
            // class: "text-primary",
            type: "emit",
            emit: "editOrder",
            badges: [
              {
                badge_if: "target_status_id",
                badge_value: "1",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.orders.status_prepare_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.targets.stopped"),
                badge_tooltip: this.$t("lang.orders.status_inactive_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "3",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.targets.pending"),
                badge_tooltip: this.$t("lang.orders.status_draft_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.running"),
                badge_tooltip: this.$t("lang.orders.status_active_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "5",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.targets.archived"),
                badge_tooltip: this.$t("lang.orders.status_achived_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value: "launch_date_campaign",
          },
        ],
        [
          {
            value: "prospecting_days",
          },
        ],
        [
          {
            value: "id",
            type: "campaignsBadge",
            formatNumber: "true",
            //loading: "false",
          },
        ],
        [
          {
            value: "total_newprospects",
          },
        ],
        [
          {
            value: "total_email_sent",
          },
        ],
        [
          {
            total: "appt_quantity",
            progress: "total_event",
            type: "progressStatus",
          },
        ],
        // [
        //   {
        //     value: "client_id",
        //     type: "imageSet",            
        //   }
        // ],
        [
          {
            value: "avg_task_day",
          }
        ],
        [
          {
            value: "conversion_rate",
          },
        ],
         [
          {
            value: "simple_meeting_rate",
          },
        ],
        [
          {
            value: "meeting_rate",
          },
        ],
        [
          {
            value: "total_event",
          },
        ],
        [
          {
            value: "revenue",
          },
        ],
        // [
        //   {
        //     value: "id",
        //     type: "statsBadge",
        //   },
        // ],
        // [
        //   {
        //     value: "profitability",
        //   },
        // ],
        // [
        //   {
        //     value: "cashable_margin",
        //   },
        // ],
        // [
        //   {
        //     value: "operating_margin",
        //   },
        // ],
        // [
        //   {
        //     value: "global_margin",
        //   },
        // ],
      ],
      headers: [
        {
          label: this.$t("lang.column.creation"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.token.order_id"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: "Opened Tasks",
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 2,
        },
        {
          label: "Closed Tasks",
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 2,
        },
        {
          label: this.$t("lang.column.name"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.column.client"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: this.$t("lang.column.duplicate_reason"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.column.status"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 2,
        },
        {
          label: this.$t("lang.column.launch_date"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 12,
        },
        {
          label: this.$t("lang.column.prospecting_days"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 3,
        },
        {
          label: this.$t("lang.label.prospectingemails"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: this.$t("lang.label.newleads"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: 'Total sent', //this.$t("lang.label.newleads"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: 'Meeting Objetive', //this.$t("lang.label.newleads"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        // {
        //   label: 'Bookers', //this.$t("lang.label.newleads"),
        //   percentage: "22.5%",
        //   class: "w-100",
        //   id: 6,
        //   permission: "adminClients",
        // },
        {
          label: 'AVG bookers tasks/day', //this.$t("lang.label.newleads"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: 'Meetings / unique prospects (month)',
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
         {
          label: "Meetings/Email sent (month)",
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: 'Meetings / unique prospects (global)',
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: 'Total event',
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: 'Revenue',
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
      //   {
      //     label: this.$t("lang.label.statistics") + "(global)",
      //     class: "overflowhide",
      //     permission: "adminClients",
      //     id: 16,
      //   },
      //  {
      //     label: 'Profitability (month)',
      //     percentage: "12.5%",
      //     class: "text-primary font-weight-bold",
      //     permission: "adminClients",
      //     id: 11,
      //   },
        // {
        //   label: 'Cashable Margin (month)',
        //   percentage: "12.5%",
        //   class: "overflowhide",
        //   permission: "adminClients",
        //   id: 11,
        // },
        // {
        //   label: 'Operating Margin (month)',
        //   percentage: "12.5%",
        //   class: "overflowhide",
        //   permission: "adminClients",
        //   id: 11,
        // },
        // {
        //   label: 'Global Margin (month)',
        //   percentage: "12.5%",
        //   class: "overflowhide",
        //   permission: "adminClients",
        //   id: 11,
        // },
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
    };
  },
  components: {
    Table,
    LoadingSpinner,
  },

  watch: {
    tabId (value) {
      this.loadOrders();
    }
  },
  mounted() {
    this.loadOrders();
    this.udpdateHeader(this.$route.name);
    this.setCurrentRouteChild({ child: "" });
  },

  props: {
    client_id: {
      type: Number,
      default: undefined,
    },
    fromClient: {
      type: Boolean,
      default: false,
    },
    condition: {
      type: String,
      default: null
    },
    tabId: {
      type: String,
      required: true
    },
    oliver_sale_id: {
      type: String,
      required: '0',
      default: '0'
    },
    account_executive: {
      type: Number,
      default: 0
    },
    showTotals: {
      type: Boolean,
      default: false
    },
    yearMonth: {
      type: String,
      default: '0'
    }
  },

  watch: {
    oliver_sale_id(newVal, oldVal) {
      if (newVal != oldVal) {
        this.loadOrders();
      }
    }
  },

  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),

    updateOrder(){
         const rowTotals = this.orders[this.orders.length - 1];
    this.orders.pop();

     this.orders = this.orders.slice().sort((a, b) => {
      const propA = a[this.orderBy] != null ? a[this.orderBy] : 0;
      const propB = b[this.orderBy] != null ? b[this.orderBy] : 0;

      let result = 0;

      // Si la propiedad es una fecha
      if (typeof propA === 'string' && !isNaN(Date.parse(propA))) {
        result = new Date(propA) - new Date(propB);
      } 
      // Si la propiedad es un número (incluyendo casos como "0.00")
      else if (!isNaN(propA) && !isNaN(propB)) {
        result = propA - propB;
      } 
      // Si la propiedad es texto
      else {
        result = propA.toString().localeCompare(propB.toString());
      }

      // Manejo especial para "0", null o cadenas vacías
      if ((propA == 0 || propA === '' || propA === null) && 
          (propB != 0 && propB !== '' && propB !== null)) {
        return this.orderDirection === 'asc' ? -1 : 1;
      }
      if ((propB == 0 || propB === '' || propB === null) && 
          (propA != 0 && propA !== '' && propA !== null)) {
        return this.orderDirection === 'asc' ? 1 : -1;
      }

      // Si la ordenación es descendente, invertir el resultado
      if (this.orderDirection === 'desc') {
        result = result * -1;
      }

      return result;
    });

      this.orders.push(rowTotals);

    },

    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    loadOrders(order, filter = []) {
      this.loading = true;
      targetsService.getTargetListToProfitability(this.tabId, 0, this.fullview, this.oliver_sale_id, this.account_executive, this.yearMonth)
        .then((response) => {
        if (response.result && Array.isArray(response.result)) {               
          response.result.map(item => {
            item.revenue = String(item.revenue);
            item.tasks = String(item.tasks);
            item.closetask = String(item.closetask);
            item.avg_task_day = String(item.avg_task_day);
          });
        }
        if (response !== undefined) {

           //Calculos para los totales o resultados, para la ultima final
           if(response.result.length > 0 && this.showTotals){
            const result = response.result

            const prospecting_day_total = result.reduce((sum, item) => sum + Number(item.prospecting_days), 0);
            const prospecting_days = prospecting_day_total && ((prospecting_day_total / result.length).toFixed(2));

            const prospectors_active_total = result.reduce((sum, item) => sum + Number(item.prospectors_total), 0);
            const prospectors_active = prospectors_active_total && (prospectors_active_total / result.length).toFixed(2);


            const total_contacted_contacts = result.reduce((sum, item) => sum + Number(item.total_contacted_contacts), 0);

            const meet_rate = result.reduce((sum, item) => sum + Number(item.meeting_rate), 0);
            const meeting_rate = meet_rate / result.length;

            const total_meetings = result.reduce((sum, item) => sum + Number(item.total_meetings), 0);
            const total_amount = result.reduce((sum, item) => sum + Number(item.total_amount), 0);

            const profitability = result.reduce((sum, item) => sum + Number(item.profitability), 0) / result.length;

            const cashable_margin_total = result.reduce((sum, item) => sum + Number(item.cashable_margin), 0);
            const cashable_margin = cashable_margin_total / result.length;

            const operating_margin_total = result.reduce((sum, item) => sum + Number(item.operating_margin), 0);
            const operating_margin = operating_margin_total / result.length;

            const global_margin_total = result.reduce((sum, item) => sum + Number(item.global_margin), 0);
            const global_margin = global_margin_total / result.length;

            const revenue = result.filter(el => el.revenue).reduce((sum, item) => sum + Number(item.revenue), 0);
            const total_event = result.filter(el => el.total_event).reduce((sum, item) => sum + Number(item.total_event), 0);
            const total_email_first = result.reduce((sum, item) => sum + Number(item.total_email1), 0)
            const total_newprospects = result.filter(el => el.total_newprospects).reduce((sum, item) => sum + Number(item.total_newprospects), 0);
            const total_email_sent = result.filter(el => el.total_email_sent).reduce((sum, item) => sum + Number(item.total_email_sent), 0);
            const conversion_rate = (total_event / total_newprospects) * 100;
            const simple_meeting_rate = result.filter(el => el.simple_meeting_rate).reduce((sum, item) => sum + Number(item.simple_meeting_rate), 0) / result.length;

            response.result.push({
                totalRow: true,
                created: "",
                target_name: "",
                target_status_id: "0",
                prospecting_days: prospecting_days,
                cashable_margin: cashable_margin.toFixed(2),
                operating_margin: operating_margin.toFixed(2),
                global_margin: global_margin.toFixed(2),
                total: "",
                name: "",
                client_id: "",
                launch_date_campaign: "",
                id: "",
                client_name: "",
                duplicate_reason: "",
                profitability: profitability.toFixed(2),
                total_revenue: "",
                task_open_hours: "",
                prospectors_total: "2",
                prospectors_warmingup: "0",
                prospectors_active: prospectors_active,
                prospectors_resting: "0",
                stats: "",
                warmup_days: "",
                simple_meeting_rate: simple_meeting_rate.toFixed(2),
                preparation_days: "86",
                total_contacted_contacts: total_newprospects, // (total_contacted_contacts / response.result.length).toFixed(2),
                total_email_sent,
                total_meetings: (total_meetings / response.result.length).toFixed(2),
                meeting_rate: meeting_rate.toFixed(2), // (meeting_rate / response.result.length).toFixed(2),
                total_amount: (total_amount / response.result.length).toFixed(2),
                total_event: total_event,
                revenue: revenue.toFixed(2),
                conversion_rate: conversion_rate.toFixed(2),
                total_newprospects
            })
          }
          //Fin Calculos para los totales o resultados, para la ultima final

          this.orders = response.result
        
          this.loading = false;
        }
      });
    },
    editOrder(index) {
      this.$router.push("/orders/" + index);
    },

    filter(event) {
      this.filters = event;
      this.loadOrders(this.orderStatus, this.filters);
    },

    openTarget(order_id) {
      let url = "/orders/" + order_id;
      window.open(url, "_blank");
    },
    openClient(client_id) {
      //"client_id", client_id);
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.banner {
  border-radius: 25em !important;
  color: #fff;
  font-size: 0.75em;
  text-align: left;
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 0.2em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: #4d4deb;
  width: 98%;
}

.banner-message {
  margin-left: 2em;
  margin-right: 2em;
}
</style>
